import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 14, viewBox: "0 0 9 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 13L7.5 7L1.5 1", stroke: "#0089AB", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRightArrow);
export default ForwardRef;
